import React, { useCallback } from 'react';
import useVideoStore from './stores/useVideoStore';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

var TITLE_MAX_LENGTH = 200;

function VideoTitle({ scheduleAutosave }) {
  var t = useTranslations();
  var titleId = useVideoStore(function(state) { return state.title_id; });
  var titleEn = useVideoStore(function(state) { return state.title_en; });
  var updateField = useVideoStore(function(state) { return state.updateField; });

  var handleTitleIdChange = useCallback(function(e) {
    updateField('title_id', e.target.value);
    if (scheduleAutosave) scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  var handleTitleEnChange = useCallback(function(e) {
    updateField('title_en', e.target.value);
    if (scheduleAutosave) scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  return (
    <div className="article-title mb-4" data-tour="title_id">
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label htmlFor="video_title_id">{t.title_id_label}</label>
            <input type="text" className="form-control" id="video_title_id" value={titleId || ''} onChange={handleTitleIdChange} maxLength={TITLE_MAX_LENGTH} placeholder={t.title_id_placeholder} required />
            <i className="form-group__bar" />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label htmlFor="video_title_en">{t.title_en_label}</label>
            <input type="text" className="form-control" id="video_title_en" value={titleEn || ''} onChange={handleTitleEnChange} maxLength={TITLE_MAX_LENGTH} placeholder={t.title_en_placeholder} />
            <i className="form-group__bar" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoTitle;
